import axios from "../axios";

class PropertyService {
    /*
    getListingFullDetailsById(id) {
        const url = `listings/${id}/full-details`;
        return new Promise((resolve, reject) => {
            axios
                .get(url)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    getListingFullDetailsBySlug(slug) {
        const url = `listings/slug/${slug}/full-details`;
        return new Promise((resolve, reject) => {
            axios
                .get(url)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
     */

    getRegisterInterestFieldsWithPropertyDetails(slug, id) {
        const url = `listings/slug/${slug}/properties/${id}/register-interest-full-details`;
        return new Promise((resolve, reject) => {
            axios
                .get(url)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
}

export default new PropertyService();
